import { TemplateRef } from '@angular/core';
import { Filters } from './filters.type';

export class FilterField<T> {
  /**
   * Filter to use
   */
  private filterValue: keyof T;
  /**
   * Label value
   */
  private getItemLabelFn: (value: any, item?: T) => string;
  /**
   * filter tempalte
   */
  filterTemplate: TemplateRef<any>;
  /**
   * filter tempalte
   */
  labelTemplate: TemplateRef<any>;
  /**
   * filters
   */
  filters: Filters<T>;
  /**
   * options length
   */
  optionsLength: number;
  /**
   * tells that the filter is not an array
   */
  ignoreArray = false;
  /**
   * visible
   */
  visible: boolean;

  /**
   * get Tooltip label
   */
  getTooltipLabelFn: (value: any, item?: T) => string;

  constructor(definition: {
    filter: keyof T;
    optionsLength?: number;
    ignoreArrayRule?: boolean;
    visible?: boolean;
    getLabel?: (value: any, item?: T) => string;
    getTooltip?: (value: any, item: T) => string;
  }) {
    this.filterValue = definition.filter;
    this.getItemLabelFn = definition.getLabel || this.defaultGetLabel.bind(this);
    this.getTooltipLabelFn = definition.getTooltip || null;
    this.optionsLength = definition.optionsLength;
    this.ignoreArray = definition.ignoreArrayRule || false;
    this.visible = definition.visible !== false;
  }

  /**
   * get the label of the filter
   * @param  {T} item
   */
  getLabel(item: T, allLangText?: string): any {
    const tmpFilter = item[this.filterValue];
    if (!tmpFilter && this.optionsLength > 1) {
      return allLangText;
    }
    if (!Array.isArray(tmpFilter) || this.ignoreArray) {
      return this.getItemLabelFn(tmpFilter, item);
    }
    if (tmpFilter.length === 1) {
      return this.getItemLabelFn(tmpFilter[0], item);
    }
    if (tmpFilter.length === 0 || tmpFilter.length === this.optionsLength) {
      return allLangText;
    }
    return tmpFilter.length;
  }

  /**
   * return true if use custom template or not
   * @param  {T} item
   */
  useTemplate(item: T): boolean {
    if (!this.labelTemplate) {
      return false;
    }
    const tmpFilter = item[this.filterValue];
    if (!tmpFilter && this.optionsLength > 1) {
      return false;
    }
    if (!Array.isArray(tmpFilter) || this.ignoreArray) {
      return true;
    }
    if (tmpFilter.length === 1) {
      return true;
    }
    return false;
  }

  /**
   * get the label of the filter
   * @param  {T} item
   */
  getTooltipLabel(item: T) {
    const tmpFilter = item[this.filterValue];
    if (this.getTooltipLabelFn) {
      return this.getTooltipLabelFn(tmpFilter, item);
    }
    if (!Array.isArray(tmpFilter) || !this.optionsLength || tmpFilter.length <= 1 || tmpFilter.length === this.optionsLength) {
      return '';
    }
    const labelFn = this.getTooltipLabelFn || this.getItemLabelFn;
    return labelFn(tmpFilter[0]) + ', ' + labelFn(tmpFilter[1]) + (tmpFilter.length > 2 ? ' (' + (tmpFilter.length - 2) + '+)' : '');
  }

  /**
   * get filter key
   * @return response
   */
  get filter() {
    return this.filterValue;
  }

  /**
   * get filter field value by key
   * @param item
   * @return response
   */
  defaultGetLabel(item: any): string {
    return item;
  }
}
